"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutStepSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _BoxSectionSkeleton = require("./BoxSectionSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(0, 3),
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 6)
        }
    };
});
const SectionWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(6, 0),
        '&:first-of-type': {
            margin: theme.spacing(0, 0, 6)
        }
    };
});
// skipped for now and will be done after redesign finalization
const CheckoutStepSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": getTestId(_models.TestId.CheckoutStepSkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BoxSectionSkeleton.BoxSectionSkeleton, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BoxSectionSkeleton.BoxSectionSkeleton, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BoxSectionSkeleton.BoxSectionSkeleton, {
                    isDelivery: true
                })
            })
        ]
    });
};
exports.CheckoutStepSkeleton = CheckoutStepSkeleton;
